// Copyright (c) 2019 Verimatrix, Inc.  All Rights Reserved.

import React, {Component} from 'react'
import {NavLink} from 'react-router-dom'
import {FormGroup, InputField} from '../../form'
import {Field, reduxForm} from 'redux-form'
import {connect} from 'react-redux'
import history from '../../../history'

import {VerimatrixLogo} from '../../../media/exports'
import ErrorIcon from '@material-ui/icons/Error'

import {activateUser} from '../../../actions/user'
import {validatePassword} from '../../../utils/validators'

import './index.css'

class ActivateUser extends Component {
  componentDidMount () {
    const {activateUser} = this.props
    if (!activateUser.username || !activateUser.password) {
      history.push('/')
    }
  }

  render () {
    const {error, handleSubmit, invalid, submitting} = this.props

    return (
      <div className='container col-md-4 col-md-offset-4'>
        <form className='form activate-user-form' onSubmit={handleSubmit}>
          {<img src={VerimatrixLogo} alt='Verimatrix Logo' className='vmx-logo'/>}
          <div className='activate-user-fields'>
            <div className='inputs'>
              <label className='lblCreatePassword'>Create a strong password</label>
              <div className='password-rules'>
                <ul>
                  <li className='lh'>{'Make sure your password meets the following requirements:'}</li>
                  <li>{'Must be at least 10 characters'}</li>
                  <li>{'Contains at least 1 upper case and 1 lower case letter'}</li>
                  <li>{'Does not use any blank spaces'}</li>
                  <li>{'Has at least 1 number'}</li>
                  <li>Includes at least 1 symbol <span className='symbols'>{'(!”#$%&’()*+,-./:;<=>?@[\\]^_{|}~)'}</span></li>
                </ul>
              </div>
              <FormGroup labelText='New Password'>
                <Field
                  name='newPassword'
                  type='password'
                  component={InputField}
                />
              </FormGroup>
              <FormGroup labelText='Confirm New Password'>
                <Field
                  name='confirmNewPassword'
                  type='password'
                  component={InputField}
                />
              </FormGroup>
              <div className='error'>
                {error && <><ErrorIcon/>{` ${error}`}</>}
              </div>
            </div>
            <FormGroup>
              <div className='buttons row'>
                <div className='col-6'>
                  <button className='btn btn-accept' type='submit' disabled={invalid || submitting}>Update</button>
                </div>
                <div className='col-6'>
                  <NavLink className='btn btn-cancel' to={`/`}>Cancel</NavLink>
                </div>
              </div>
            </FormGroup>
          </div>
        </form>
      </div>
    )
  }
}

function onSubmit (values, dispatch) {
  dispatch(activateUser(values))
}

export function validate (values) {
  let ret = {}

  if (!values.newPassword || !values.newPassword.trim()) {
    ret = {...ret, newPassword: 'Password cannot be blank'}
  }

  if (values.newPassword && !validatePassword(values.newPassword)) {
    ret = {...ret, newPassword: 'New password does not meet requirements'}
  }

  if (!values.confirmNewPassword || !values.confirmNewPassword.trim()) {
    ret = {...ret, confirmNewPassword: 'Password cannot be blank'}
  }

  if (values.confirmNewPassword !== values.newPassword) {
    ret = {...ret, confirmNewPassword: 'Passwords should match'}
  }

  return ret
}

function mapStateToProps ({activateUser}) {
  return {activateUser}
}

const ActivateUserRedux = connect(mapStateToProps)(ActivateUser)

export default reduxForm({
  form: 'activateUser',
  onSubmit: onSubmit,
  validate: validate
})(ActivateUserRedux)
